(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    } catch { return `$${(cents / 100).toFixed(2)}`; }
  };

  const announce = $('[data-announce]');
  if (announce) {
    const items = $$('.announce__item', announce);
    let i = 0;
    const speed = (Number(announce.dataset.speed) || 5) * 1000;
    if (items.length > 1) {
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    }
  }

  const navDrawer = $('#NavDrawer');
  $$('.js-open-nav').forEach((b) => b.addEventListener('click', () => navDrawer?.classList.add('is-open')));
  $$('.js-close-nav').forEach((b) => b.addEventListener('click', () => navDrawer?.classList.remove('is-open')));

  const qv = $('#QuickView');
  const openQv = (html) => {
    if (!qv) return;
    qv.hidden = false;
    qv.classList.add('is-open');
    $('[data-qv-body]', qv).innerHTML = html;
  };
  const closeQv = () => { qv?.classList.remove('is-open'); if (qv) qv.hidden = true; };
  $$('.js-close-qv').forEach((b) => b.addEventListener('click', closeQv));
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-quick-view');
    if (!btn) return;
    e.preventDefault();
    const url = btn.dataset.productUrl;
    const res = await fetch(`${url}?view=quick`);
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const info = doc.querySelector('.product__info, .product') || doc.body;
    openQv(info.innerHTML);
  });

  const searchForm = $('[data-predictive-search]');
  const results = $('[data-predictive-results]');
  if (searchForm && results) {
    const input = $('input[name="q"]', searchForm);
    let t;
    input?.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.classList.remove('is-open'); results.hidden = true; return; }
      t = setTimeout(async () => {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`);
        const data = await res.json();
        const products = data.resources?.results?.products || [];
        const collections = data.resources?.results?.collections || [];
        results.innerHTML = [
          products.length ? `<p class="kicker">Products</p>` : '',
          ...products.map((p) => `<a href="${p.url}"><img src="${p.featured_image?.url || ''}" alt=""><span>${p.title}<br><small>${p.price}</small></span></a>`),
          collections.length ? `<p class="kicker">Collections</p>` : '',
          ...collections.map((c) => `<a href="${c.url}">${c.title}</a>`)
        ].join('');
        results.hidden = false;
        results.classList.add('is-open');
      }, 180);
    });
    document.addEventListener('click', (e) => {
      if (!searchForm.contains(e.target)) { results.classList.remove('is-open'); results.hidden = true; }
    });
  }

  $$('[data-tabs]').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tab]');
      if (!btn) return;
      $$('.tabs__btn', wrap).forEach((b) => b.classList.toggle('is-active', b === btn));
      $$('.tabs__panel', wrap).forEach((p) => p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab));
    });
  });

  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const d = Math.floor(left / 86400000);
      const h = Math.floor((left % 86400000) / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('[data-d]', d); set('[data-h]', h); set('[data-m]', m);
    };
    tick();
    setInterval(tick, 30000);
  });

  const PROMO_KEY = 'ventora-promo-end';
  const PROMO_MS = 60 * 60 * 1000;
  const getPromoEnd = () => {
    const raw = localStorage.getItem(PROMO_KEY);
    const stored = Number(raw);
    if (raw && Number.isFinite(stored)) return stored;
    const end = Date.now() + PROMO_MS;
    localStorage.setItem(PROMO_KEY, String(end));
    return end;
  };
  const promoLeft = () => Math.max(0, getPromoEnd() - Date.now());
  const promoExpired = () => promoLeft() <= 0;
  const formatPromo = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };
  const paintPromo = () => {
    const nodes = $$('[data-ventora-promo]');
    if (!nodes.length) return;
    const expired = promoExpired();
    const label = expired ? '0:00:00' : formatPromo(promoLeft());
    nodes.forEach((el) => {
      el.classList.toggle('is-expired', expired);
      $$('[data-promo-timer]', el).forEach((n) => { n.textContent = label; });
    });
    if (expired) {
      const welcome = $('[data-welcome-popup]');
      if (welcome) {
        welcome.classList.remove('is-open');
        welcome.hidden = true;
        document.body.style.overflow = '';
      }
    }
  };
  paintPromo();
  setInterval(paintPromo, 1000);
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-promo-apply]');
    if (link && promoExpired()) e.preventDefault();
  });

  $$('[data-booster-section]').forEach((sec) => {
    sec.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (!chip) return;
      $$('.chip', sec).forEach((c) => c.classList.toggle('is-active', c === chip));
      const tag = chip.dataset.filter;
      $$('[data-tags]', sec).forEach((card) => {
        card.style.display = tag === 'all' || card.dataset.tags.includes(tag) ? '' : 'none';
      });
    });
  });

  const KEY = 'ventora-wishlist';
  const readWish = () => JSON.parse(localStorage.getItem(KEY) || '[]');
  const writeWish = (v) => localStorage.setItem(KEY, JSON.stringify(v));
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-wishlist');
    if (!btn) return;
    const handle = btn.dataset.productHandle;
    const list = readWish();
    const next = list.includes(handle) ? list.filter((h) => h !== handle) : [...list, handle];
    writeWish(next);
    btn.setAttribute('aria-pressed', String(next.includes(handle)));
  });

  const grid = $('#WishlistGrid');
  const empty = $('#WishlistEmpty');
  if (grid) {
    const handles = readWish();
    if (!handles.length) { if (empty) empty.hidden = false; }
    else {
      Promise.all(handles.map((h) => fetch(`/products/${h}.js`).then((r) => r.ok ? r.json() : null)))
        .then((products) => {
          grid.innerHTML = products.filter(Boolean).map((p) => `
            <article class="pcard">
              <div class="pcard__media"><a href="/products/${p.handle}"><img src="${p.featured_image}" alt="${p.title}"></a></div>
              <div class="pcard__body">
                <a class="pcard__title" href="/products/${p.handle}">${p.title}</a>
                <div class="price">${money(p.price)}</div>
                <button class="btn btn-primary js-quick-add" data-id="${p.variants[0].id}">Add to cart</button>
              </div>
            </article>`).join('');
        });
    }
  }

  $$('.js-share').forEach((b) => b.addEventListener('click', () => {
    if (navigator.share) navigator.share({ title: document.title, url: location.href });
    else navigator.clipboard?.writeText(location.href);
  }));

  $$('.js-open-filters').forEach((b) => b.addEventListener('click', () => $('#Filters')?.classList.add('is-open')));

  const LAST_TCG = 'ventora-last-tcg';
  const saveLastTcg = (href, title) => {
    if (!href || href.endsWith('tcgplayer.com.lc') || href.endsWith('tcgplayer.com.lc/')) return;
    sessionStorage.setItem(LAST_TCG, JSON.stringify({ href, title: title || '' }));
  };
  const readLastTcg = () => {
    try { return JSON.parse(sessionStorage.getItem(LAST_TCG) || 'null'); } catch { return null; }
  };

  const productTcg = $('[data-tcg-cart]');
  const welcome = $('[data-welcome-popup]');
  const welcomeLink = welcome ? $('[data-welcome-tcg]', welcome) : null;
  const currentProductUrl = welcomeLink?.dataset.tcgProductUrl || productTcg?.dataset.tcgProductUrl || '';
  const currentTcgHref = currentProductUrl || (welcomeLink?.dataset.tcgMode && welcomeLink.dataset.tcgMode !== 'store' ? welcomeLink.href : '') || productTcg?.href || '';
  if (currentTcgHref) {
    saveLastTcg(currentTcgHref, welcome?.dataset.productTitle || productTcg?.getAttribute('aria-label') || document.title);
  }

  if (welcome) {
    const key = 'ventora-welcome-seen';
    const link = welcomeLink;
    const stored = readLastTcg();
    if (link && stored?.href && link.dataset.tcgMode === 'store') {
      const store = (link.dataset.tcgStore || 'https://tcgplayer.com.lc').replace(/\/$/, '');
      const coupon = (link.dataset.tcgCoupon || 'VENTORA15').trim().toUpperCase();
      try {
        const dest = new URL(stored.href);
        const redirect = `${dest.pathname}${dest.search}`;
        link.href = `${store}/discount/${encodeURIComponent(coupon)}?redirect=${encodeURIComponent(redirect)}`;
      } catch {
        link.href = stored.href;
      }
      if (stored.title) link.setAttribute('aria-label', stored.title);
    }
    const open = () => {
      if (promoExpired()) return;
      welcome.hidden = false;
      requestAnimationFrame(() => welcome.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      welcome.classList.remove('is-open');
      document.body.style.overflow = '';
      sessionStorage.setItem(key, '1');
      setTimeout(() => { welcome.hidden = true; }, 320);
    };
    $$('.js-welcome-close', welcome).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && welcome.classList.contains('is-open')) close();
    });
    $('[data-welcome-code]') && $('.js-welcome-copy', welcome)?.addEventListener('click', async () => {
      const btn = $('.js-welcome-copy', welcome);
      const code = btn?.dataset.code || '';
      try { await navigator.clipboard.writeText(code); } catch {}
      const note = $('small', btn);
      if (note) { note.textContent = 'Copied'; setTimeout(() => { note.textContent = 'Copy'; }, 1600); }
    });
    if (!sessionStorage.getItem(key) && !promoExpired()) {
      setTimeout(open, Math.max(200, Number(welcome.dataset.delay || 800)));
    }
  }

  window.Ventora = window.Helion = { money, readWish, writeWish };
})();
